import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import {
  HelperService,
  AppSettings,
  AuthenticationService,
  Agents,
} from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-available-subscriptions',
  templateUrl: './ai-subscriptions.component.html',
  styleUrls: ['./ai-subscriptions.component.css'],
})
export class AISubscriptionsComponent implements OnInit {
  public despositionArray: any = AppSettings.dispositionSubscription;
  public planTypeArray: any = (() => {
    const result = [
      { name: 'All', value: 'all' },
      ...AppSettings.planTypeArray,
    ];
    return result;
  })();
  public statusArray: any = (() => {
    const original = [...AppSettings.SubscriptionStatus];
    const insertAfter = 'renewal_failed';
    const newItem = { name: 'Trial', value: 'starter' };

    const result = [];
    for (let i = 0; i < original.length; i++) {
      result.push(original[i]);
      if (original[i].value === insertAfter) {
        result.push(newItem);
      }
    }
    return result;
  })();
  public dispFirstEle: any;
  public documentTypeArray: any = AppSettings.documentType;
  public siteAbbr: any = AppSettings.aiSiteAbbr;
  public orderStatus: any = AppSettings.orderStatus;
  public aiSiteList: any = AppSettings.aiSiteList;
  public ReturningNewList: any = [
    { value: 'all', label: 'All' },
    { value: '1', label: 'New User' },
    { value: 'returning', label: 'Returning' },
  ];

  public loading: any = false;
  public submitted: any = false;
  public paginatePage: any;
  public subscriptions: any = [];
  public subscriptions_Copy: any = [];
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public agentsSub: any;
  public agents: any;
  public qa: any;
  public loader: any;
  public qaloader: any;
  public activeUser: any;
  public notes: any = '';
  public lead_Index: any = null;
  public addCommentForm: FormGroup;
  public isMySubTab: any = false;
  public role: any = null;
  public limitExceeded: any = false;
  public leadStatusToUpdate: any = false;
  public floatingAlert: any = true;
  public salesIndex: any = null;
  public salesStatusVal: any = null;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = {
    renewal_status: 'all',
    site_link: null,
    emailId: '',
    plan_type: 'all',
    disposition: null,
    status: null,
    agent_id: [],
    date_from: '',
    date_to: '',
    work_type: null,
  };
  // public fullRangeDate: string[] = this.getDateRange();
  public fullRangeDate: string[] = this.getDateRange();

  private getDateRange(): string[] {
    // Get current date/time in America/Los_Angeles
    const nowInLA = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
    );
    console.log('Los Angeles current time:', nowInLA);
    // Set time to 00:00:00 for consistency (optional)
    nowInLA.setHours(0, 0, 0, 0);

    const formatDate = (date: Date): string => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    };

    // Return the same date twice (start and end)
    return [formatDate(nowInLA), formatDate(nowInLA)];
  }

  public selectedDesposition: any;
  public actionUpdated: any;

  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    // Get Agents
    this.splitFromTo(false);
    this.agentsSub = this.agentsService.agentsS$.subscribe((agents) => {
      if (agents) {
        this.agents = agents.agents;
        this.qa = agents.qa;
      }
    });

    this.activeUser = this.authenticationService.get_currentUserValue();
    this.role = this.authenticationService.get_currentUserRole();

    this.dtOptions = {
      paging: true,
      info: true,
      pagingType: 'full_numbers',
      pageLength: 25,
      serverSide: true,
      processing: true,
      searching: false,
      language: AppSettings.dataTableLang,
      columnDefs: [
        { orderable: false, targets: 0 },
        { orderable: true, targets: 1 },
        { orderable: false, targets: 2 },
        {
          orderable: false,
          visible: this.searchParams.status !== 'starter',
          targets: 3,
        },
        { orderable: false, targets: 4 },
        {
          orderable: false,
          visible: this.searchParams.status !== 'starter',
          targets: 5,
        },
        { orderable: false, targets: 6 },
        { orderable: false, targets: 7 },
        { orderable: true, targets: 8 },
        { orderable: false, targets: 9 },
        { orderable: false, visible: !this.isMySubTab, targets: 10 },
        { orderable: false, visible: this.isMySubTab, targets: 11 },
        { orderable: false, targets: 12 },
      ],
      order: [[1, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        this.loading = true;

        let url;
        if (!this.isMySubTab) {
          url = AppSettings.API_ENDPOINT + 'admin/available-subscriptions';
        } else if (this.isMySubTab) {
          url = AppSettings.API_ENDPOINT + 'sales/my-subscriptions';
        }

        if (dataTablesParameters.order[0].column == 8) {
          this.searchParams.status = 'success';
        }

        let dtParams = {
          search: this.searchParams.emailId,
          disposition:
            this.searchParams.disposition == null
              ? this.searchParams.disposition
              : this.searchParams.disposition.toString(),
          status: this.searchParams.status,
          agent_id: this.searchParams.agent_id,
          site_link: this.searchParams.site_link,
          date_from: this.searchParams.date_from
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_from
              )
            : this.helperService.caonvertDateToString(this.fullRangeDate[0]),
          date_to: this.searchParams.date_to
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_to,
                false
              )
            : this.helperService.caonvertDateToString(
                this.fullRangeDate[1],
                false
              ),
          work_type:
            this.searchParams.work_type &&
            this.searchParams.work_type.length > 0
              ? this.searchParams.work_type
              : null,
          plan_type:
            this.searchParams.plan_type === 'all'
              ? null
              : this.searchParams.plan_type ?? null,
          renewal_status:
            this.searchParams.renewal_status === 'all'
              ? null
              : this.searchParams.renewal_status ?? null,
          start: dataTablesParameters.start,
          length: dataTablesParameters.length,
          order: dataTablesParameters.order,
          columns: dataTablesParameters.columns,
        };
        console.log('dtParams: ', dtParams);

        this.paginatePage = dataTablesParameters.start;
        this.subscriptions = [];

        this.helperService
          .httpPostRequestsDecryp(url, dtParams)
          .then((resp) => {
            this.subscriptions = JSON.parse(resp);
            console.log('this.subscriptions: ', this.subscriptions);

            this.subscriptions_Copy = $.extend(true, {}, this.subscriptions);
            $.each(this.subscriptions.statusCounts, (index, value) => {
              // console.log("index: ", index, " value: ", value);
              let val_text;
              if (value >= 9000) {
                val_text = '9K+';
              } else if (value >= 1000) {
                const thousands = Math.floor(value / 1000);
                val_text =
                  value % 1000 === 0 ? `${thousands}K` : `${thousands}K+`;
              } else {
                val_text = value;
              }

              $('#' + index).html(val_text);
            });
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();
            this.loading = false;

            callback({
              recordsTotal: this.subscriptions.total,
              recordsFiltered: this.subscriptions.total,
              data: [],
            });

            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch((error) => {
            this.loading = false;
            console.log('error: ', error);
          });
      },
      columns: [
        { data: 'id' },
        { data: 'created_at' },
        { data: 'email' },
        { data: 'price' },
        { data: 'total_paid' },
        { data: 'period' },
        { data: 'max_words' },
        { data: 'consumed_word' },
        { data: 'nearby_expiring_date' },
        { data: 'disposition_id' },
        { data: 'agent_id' },
        { data: 'notes' },
        { data: 'comments' },
      ],
      responsive: false,
    };
  }

  ngOnInit() {
    this.updatePlanTypeArray();
    this.addCommentForm = this.formBuilder.group({
      comment: [null, Validators.required],
    });

    if (this.activeUser.Portal_Sales) {
      this.checkIfleadsAllowed();
    }
  }
  updatePlanTypeArray() {
    const shouldSkipTrial = this.searchParams?.status === 'success';
    const filteredArray = shouldSkipTrial
      ? AppSettings.planTypeArray.filter((plan) => plan.value !== 'starter')
      : AppSettings.planTypeArray;

    this.planTypeArray = [{ name: 'All', value: 'all' }, ...filteredArray];
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();

      if (this.searchParams.status !== 'success') {
        this.dtOptions.order = [[1, 'desc']];
      }

      this.checkStatus();

      this.dtTrigger.next();
    });
  }

  splitFromTo(rerender = true) {
    if (this.fullRangeDate) {
      console.log('this.fullRangeDate', this.fullRangeDate);
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }
    if (rerender) {
      this.rerender();
    }
  }

  checkIfleadsAllowed() {
    let url = AppSettings.API_ENDPOINT + 'sales/check-if-leads-allowed';
    let data = { id: this.activeUser.user.id, status: 1 };
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        if (resp.data.limit_exceeded) {
          this.limitExceeded = true;
        }
      }
    });
  }

  getSubscriptionStatusCount() {
    let url = AppSettings.API_ENDPOINT + 'admin/getSubscriptionStatusCount';
    let data = {
      search: this.searchParams.emailId,
      disposition:
        this.searchParams.disposition == null
          ? this.searchParams.disposition
          : this.searchParams.disposition.toString(),
      status: this.searchParams.status,
      agent_id: this.searchParams.agent_id,
      site_link: this.searchParams.site_link,
      date_from: this.searchParams.date_from
        ? this.helperService.caonvertDateToString(this.searchParams.date_from)
        : '',
      date_to: this.searchParams.date_to
        ? this.helperService.caonvertDateToString(
            this.searchParams.date_to,
            false
          )
        : '',
      work_type:
        this.searchParams.work_type && this.searchParams.work_type.length > 0
          ? this.searchParams.work_type
          : null,
      plan_type: this.searchParams.plan_type ?? null,
    };
    this.helperService.httpPostRequestsDecryp(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        if (resp.data) {
          console.log(resp.data);
        }
      }
    });
  }

  openChangeDesposition(lead, index) {
    this.notes = '';
    this.salesIndex = index;
    this.salesStatusVal = this.subscriptions.data[index].status;
    this.submitted = false;

    let self = this;
    setTimeout(() => {
      self.subscriptions.data[index].status =
        self.subscriptions_Copy.data[index].status;
    }, 50);

    this.subscriptions.data[index].loadingComms = true;

    let url = AppSettings.API_ENDPOINT + 'shared/get-subscription-comments';
    let data = { l: lead.id, type: '' };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.comments = resp.data;
          this.subscriptions.data[index].oldComms = [];
          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Leads-Comments') {
              this.subscriptions.data[index].oldComms.push(this.comments[i]);
            }
          }
        }

        $('#commentsSubscriptionsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsSubscriptionsModal' + index).modal('hide');
        });

        this.subscriptions.data[index].loadingComms = false;
      })
      .catch((err) => {
        $('#commentsSubscriptionsModal' + index).modal('show');
        $('.modal-backdrop').click(function () {
          $('#commentsSubscriptionsModal' + index).modal('hide');
        });

        this.subscriptions.data[index].loadingComms = false;
      });
  }

  updateCommentsAndDisposition(lead, index) {
    this.submitted = true;
    if (this.addCommentForm.invalid) {
      return;
    }

    this.loading = true;

    let url =
      AppSettings.API_ENDPOINT +
      'shared/update-subscription-comments-and-disposition';
    let data = {
      id: lead.id,
      disposition: this.getNameByValue(lead.disposition_id),
      disposition_id: lead.disposition_id,
      status: this.salesStatusVal.toString(),
      comments: this.notes,
    };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.notes = '';
          this.cdr.detectChanges();
          Swal.fire('', resp.message, 'success');
        }
        this.loading = false;

        $('#commentsSubscriptionsModal' + this.salesIndex).modal('hide');
        $('.modal-backdrop').remove();

        this.rerender();
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');
        this.loading = false;
      });

    this.submitted = false;
  }

  showComments(lead, index, type = '') {
    this.agentComments = [];
    this.qaComments = [];

    if (type == 'QA-Leads-Comments') {
      this.qaloader = lead.id;
    } else {
      this.loader = lead.id;
    }

    let url = AppSettings.API_ENDPOINT + 'shared/get-subscription-comments';
    let data = { l: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then((resp) => {
      if (typeof resp != 'undefined') {
        this.comments = resp.data;

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == 'Subscription-Leads-Comments') {
            this.agentComments.push(this.comments[i]);
          } else if (this.comments[i].type == 'QA-Leads-Comments') {
            this.qaComments.push(this.comments[i]);
          }
        }

        if (type == 'QA-Leads-Comments') {
          $('#notesModal' + index).modal('show');
        } else {
          if (
            type == '' &&
            this.agentComments.length == 0 &&
            this.qaComments.length == 0
          ) {
            Swal.fire(
              'No comments',
              "Agents and QA haven't added any comments yet.",
              'info'
            );
          } else if (
            type == 'Leads-Comments' &&
            this.agentComments.length == 0
          ) {
            Swal.fire(
              'No comments',
              "Agents haven't added any comments yet.",
              'info'
            );
          } else {
            if (typeof $ != 'undefined') {
              $('#comment_modal' + index).modal('show');
            }
          }
        }

        this.loader = '';
        this.qaloader = '';

        $('.modal-backdrop').click(function () {
          $('#comment_modal' + index).modal('hide');
        });
      }
    });
  }

  openNotesModal(index) {
    this.submitted = false;
    this.notes = '';
    $('#notesModal' + index).modal('show');
  }

  get f() {
    return this.addCommentForm.controls;
  }

  updateSelfComments(lead, index) {
    this.submitted = true;
    if (this.addCommentForm.invalid) {
      return;
    }

    this.loading = true;

    let url =
      AppSettings.API_ENDPOINT +
      'shared/update-self-comments-for-subscriptions';
    let data = { id: lead.id, comments: this.notes };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          this.subscriptions.data[index].self_comments = this.notes;
          this.notes = '';
          this.cdr.detectChanges();

          $('#notesModal' + index).modal('hide');
          $('.modal-backdrop').remove();

          let self = this;
          this.subscriptions.data[index].noteUpdated = true;
          setTimeout(() => {
            self.subscriptions.data[index].noteUpdated = false;
          }, 1000);
        }

        this.loading = false;
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');
        this.loading = false;
      });
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
    return '';
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
    return '';
  }

  totalStatusSearch(status) {
    for (var i = 0; i < this.statusArray.length; i++) {
      if (this.statusArray[i].value === status) {
        return this.statusArray[i].name;
      }
    }
    return status;
  }

  showDisposition(id, statusArr) {
    for (var i = 0; i < statusArr.length; i++) {
      if (statusArr[i].value === id) {
        return statusArr[i].name;
      }
    }
    return '';
  }

  clearFilters() {
    this.fullRangeDate = null;
    this.searchParams = {
      renewal_status: 'all',
      site_link: null,
      emailId: '',
      plan_type: 'all',
      disposition: null,
      // status: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      work_type: null,
    };
    this.rerender();
  }

  openAssignToMe_Sales_Modal(index) {
    this.lead_Index = index;
    ($('#sales_assignme_modal' + index) as any).modal('show');
    $('.modal-backdrop').click(function () {
      $('#sales_assignme_modal' + index).modal('hide');
    });
  }

  assignToMe_Sales() {
    ($('#sales_assignme_modal' + this.lead_Index) as any).modal('hide');
    $('.modal-backdrop').remove();

    this.subscriptions.data[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + 'sales/assign-subscription-to-me';
    let data = { id: this.subscriptions.data[this.lead_Index].id, status: 1 };
    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        this.subscriptions.data[this.lead_Index].loading = false;

        if (typeof resp != 'undefined' && resp.status == 'OK') {
          Swal.fire('', resp.message, 'success');
          this.subscriptions.data.splice(this.lead_Index, 1);
        }

        if (typeof resp != 'undefined' && resp.status == 'ERROR') {
          Swal.fire('', resp.message, 'error');
        }
      })
      .catch((err) => {
        this.subscriptions.data[this.lead_Index].loading = false;
        Swal.fire('', err.error.message, 'error');
      });
  }

  switchSubTab(flag) {
    if (this.isMySubTab != flag) {
      this.isMySubTab = flag;

      if (this.isMySubTab) {
        if (this.despositionArray[0].value == 0) {
          let arr = $.extend(true, [], this.despositionArray);
          this.dispFirstEle = arr.shift();
          this.despositionArray = arr;
        }
        this.dtOptions.columnDefs[8].visible = false;
        this.dtOptions.columnDefs[9].visible = false;
        this.dtOptions.columnDefs[10].visible = true;
      } else {
        if (this.despositionArray[0].value != 0) {
          let arr = $.extend(true, [], this.despositionArray);
          arr.unshift(this.dispFirstEle);
          this.despositionArray = arr;
        }
        this.dtOptions.columnDefs[8].visible = true;
        this.dtOptions.columnDefs[9].visible = true;
        this.dtOptions.columnDefs[10].visible = false;
      }

      this.rerender();
    }
  }

  public getNameByValue(value: number): string {
    const element = this.despositionArray.find(
      (item: any) => item.value === value
    );
    return element ? element.name : 'Not found';
  }

  closeFloatingAlert() {
    this.floatingAlert = false;
  }

  setStatusFilter(value: string) {
    this.searchParams.status = value;

    if (value === 'starter') {
      this.searchParams.plan_type = null;
    }

    // Update the plan type array based on new status
    this.updatePlanTypeArray();

    console.log('searchParams: ', this.searchParams);
    this.rerender();
  }

  checkStatus() {
    this.dtOptions.columnDefs[3] = {
      orderable: false,
      visible: this.searchParams.status !== 'starter',
      targets: 3,
    };
    this.dtOptions.columnDefs[4] = {
      orderable: false,
      visible:
        this.searchParams.status !== 'pending' &&
        this.searchParams.status !== 'failed' &&
        this.searchParams.status !== 'renewal_failed' &&
        this.searchParams.status !== 'canceled',
      targets: 4,
    };
    this.dtOptions.columnDefs[5] = {
      orderable: false,
      visible:
        this.searchParams.status !== 'starter' &&
        this.searchParams.status !== 'pending' &&
        this.searchParams.status !== 'failed',
      targets: 5,
    };
    this.dtOptions.columnDefs[7] = {
      orderable: false,
      visible: this.searchParams.status !== 'pending',
      targets: 7,
    };
  }
}
